/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Export
 */
export interface Export {
  /**
   *
   * @type {string}
   * @memberof Export
   */
  fileHandle: string
}

/**
 * Check if a given object implements the Export interface.
 */
export function instanceOfExport(value: object): boolean {
  if (!('fileHandle' in value)) return false
  return true
}

export function ExportFromJSON(json: any): Export {
  return ExportFromJSONTyped(json, false)
}

export function ExportFromJSONTyped(json: any, ignoreDiscriminator: boolean): Export {
  if (json == null) {
    return json
  }
  return {
    fileHandle: json['fileHandle'],
  }
}

export function ExportToJSON(value?: Export | null): any {
  if (value == null) {
    return value
  }
  return {
    fileHandle: value['fileHandle'],
  }
}
